
export const GET_SUPER_ADMIN_DASHBOARD = 'get_super_admin_dashboard';
export const GET_SUPER_ADMIN_DASHBOARD_SUCCESS = 'get_super_admin_dashboard_success';
export const GET_Graph_DASHBOARD = 'get_graph_dashboard';
export const GET_Graph_DASHBOARD_SUCCESS = 'get_graph_dashboard_success';